(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1906],{

/***/ 71426:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/xuat-khau",
      function () {
        return __webpack_require__(48802);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ XuatKhau; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./apis/queryFunctions/ecompagesFunctions.js
var ecompagesFunctions = __webpack_require__(4088);
// EXTERNAL MODULE: ./common/components/DefaultSEO.js
var DefaultSEO = __webpack_require__(51623);
// EXTERNAL MODULE: ./common/components/HomeNews.js
var HomeNews = __webpack_require__(85654);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(38623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./public/HeadOfPage.png
var HeadOfPage = __webpack_require__(82245);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/appendImageUrlFromAPI.js
var appendImageUrlFromAPI = __webpack_require__(22312);
// EXTERNAL MODULE: ./common/components/PageContainer.js
var PageContainer = __webpack_require__(41291);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(54777);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(62679);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 114 modules
var motion = __webpack_require__(2020);
// EXTERNAL MODULE: ./common/Typography/TitleCus.js
var TitleCus = __webpack_require__(95197);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./setup/locale-provider/index.js
var locale_provider = __webpack_require__(59963);
// EXTERNAL MODULE: ./utils/sanitizeDOMData.js
var sanitizeDOMData = __webpack_require__(60959);
;// CONCATENATED MODULE: ./pages/xuat-khau/components/Info.js













function Info(param) {
    var _title = param.title, title = _title === void 0 ? "Why to choose" : _title, label = param.label, _picture = param.picture, picture = _picture === void 0 ? "https://zengroup.com.vn/wp-content/uploads/2022/04/du-an-nha-mat-tien-Q12-1024x768.jpg" : _picture, index = param.index;
    var ref, ref1, ref2, ref3;
    var link = picture || null;
    if (link != null) {
        if (link && link.indexOf("http") < 0) {
            link = "".concat("https://api.flexzen.app").concat(link, "?access_token=").concat("flex.public.token", "&trustkey=").concat("APP.FKJSHHHH908KJF");
        }
    }
    var isTablet = (0,useWindowSize/* default */.Z)().isTablet;
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    var locale = (0,router.useRouter)().locale;
    var data = (0,ecompagesFunctions/* useFetchEcompage */.VM)("trang-xuat-khau-viet-thien", locale).data;
    var infoXuatkhau = ((data === null || data === void 0 ? void 0 : data.add_on_data) || []).slice(0, 5);
    var infoXuatkhau2 = ((data === null || data === void 0 ? void 0 : data.add_on_data_2) || []).slice(0, 5);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                component: "section",
                sx: {
                    background: "#FFF"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        sx: {
                            paddingBottom: 30
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                                my: "xs",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                    order: 1,
                                    size: isTablet ? 24 : 36,
                                    weight: 950,
                                    align: "center",
                                    pb: 10,
                                    sx: {
                                        color: "#12854F" /* theme.colors.main[5] */ 
                                    },
                                    children: (0,sanitizeDOMData/* default */.Z)(infoXuatkhau2 === null || infoXuatkhau2 === void 0 ? void 0 : (ref = infoXuatkhau2[0]) === null || ref === void 0 ? void 0 : ref.title)
                                }),
                                labelPosition: "center"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                                pt: 20,
                                justify: "space-between",
                                align: "start",
                                children: infoXuatkhau.map(function(info, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* Grid.Col */.r.Col, {
                                        xs: 12,
                                        md: 3,
                                        align: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                            whileHover: {
                                                scale: 1.05
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: (0,appendImageUrlFromAPI/* default */.Z)({
                                                            src: info === null || info === void 0 ? void 0 : info.picture,
                                                            size: "l"
                                                        }),
                                                        alt: "".concat(info === null || info === void 0 ? void 0 : info.title),
                                                        width: 128,
                                                        height: 128
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                size: 36,
                                                                weight: 950,
                                                                style: {},
                                                                children: (0,sanitizeDOMData/* default */.Z)(info === null || info === void 0 ? void 0 : info.title)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                                size: 24,
                                                                weight: 450,
                                                                children: (0,sanitizeDOMData/* default */.Z)(info === null || info === void 0 ? void 0 : info.content)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                component: "section",
                sx: {
                    background: "#FFF"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        size: "md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                size: 36,
                                weight: 950,
                                align: "left",
                                c: "#212F3B",
                                ta: "justify",
                                sx: {
                                    lineHeight: "28px"
                                },
                                children: (0,sanitizeDOMData/* default */.Z)(infoXuatkhau2 === null || infoXuatkhau2 === void 0 ? void 0 : (ref1 = infoXuatkhau2[0]) === null || ref1 === void 0 ? void 0 : ref1.content)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        size: "xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            sx: {
                                position: "relative",
                                aspectRatio: "1.5"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,appendImageUrlFromAPI/* default */.Z)({
                                    src: (ref2 = infoXuatkhau2[0]) === null || ref2 === void 0 ? void 0 : ref2.picture
                                }),
                                alt: "".concat((ref3 = infoXuatkhau2[0]) === null || ref3 === void 0 ? void 0 : ref3.title),
                                layout: "fill",
                                objectFit: "contain"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/xuat-khau/index.page.js
/* eslint-disable react/no-array-index-key */ 










var __N_SSG = true;
function XuatKhau(param) {
    var dataSEO = param.dataSEO;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,ecompagesFunctions/* useFetchEcompage */.VM)("trang-xuat-khau-viet-thien", locale), detail = ref.data;
    // console.log('detail', detail)
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultSEO/* default */.Z, {
                seo: dataSEO
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Skeleton/* Skeleton */.O, {
                        visible: !detail,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                sx: {
                                    position: "relative",
                                    width: "100%",
                                    aspectRatio: "2.55"
                                },
                                children: Boolean(detail) && (detail === null || detail === void 0 ? void 0 : detail.picture) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: (0,appendImageUrlFromAPI/* default */.Z)({
                                        src: detail === null || detail === void 0 ? void 0 : detail.picture,
                                        size: "xl"
                                    }),
                                    alt: detail === null || detail === void 0 ? void 0 : detail.title,
                                    layout: "fill",
                                    // objectFit="cover"
                                    priority: true,
                                    quality: 100
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                sx: {
                                    objectPosition: "bottom" /* , background:"pink" */ ,
                                    marginTop: "-5%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: HeadOfPage/* default */.Z,
                                    alt: "paint",
                                    objectFit: "cover"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        sx: {
                            background: "#F8F8F8",
                            padding: "1px 0 70px 0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNews/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3987,296,5907,9774,2888,179], function() { return __webpack_exec__(71426); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);